export default "__VITE_ASSET__Bvg1kPje__"